import { Api } from 'api/commissionEnv'
var api = new Api()
export const URL_commissionGMLogin = api.GMURL + '/user/login'
export const URL_commissionUKLogin = api.UKURL + '/user/login'
export const URL_commissionLogin = api.commissionURl + '/user/signin'
export const URL_commissionLogin20 = api.commissionURl20 + '/user/signin'

export const URL_SALESSET = 'sales/set' // ��ȡ����������Ӷ���趨
export const URL_SALESSPECIAL = 'sales/special' // ��ȡ�ر������Ϣ
export const URL_SALESEXTRA = 'sales/extra' // ��ȡ�����Ա��
export const URL_SALESPREVIEW = 'sales/preview' // ��ȡ����Ӷ��Ԥ������
export const URL_SALELIST = 'sales/list' // ��ȡ���������б�

export const URL_IBALL = 'ib/all' // ��ȡ���д����б�
export const URL_IBSET = 'ib/set' // ��ȡ�����´���Ӷ���趨
export const URL_IBRULE = 'ib/rule' // ��ȡ�����´��������趨
export const URL_SALESDEL = 'sales/del' // ɾ������Ӷ���趨

export const URL_IBPREVIEW = 'ib/preview' //��ȡ ����Ӷ��Ԥ������
export const URL_IBCPA = 'ib/cpa' ///��ȡ CPA���� ����

export const URL_SYMBOLSPREAD = 'symbol/spread' //��ȡ�����¼ӵ��趨������
export const URL_SYMBOLOTHER = 'symbol/other' //���ʣ��Ļ��Ҷ�����
export const URL_SYMBOLDEL = 'symbol/del' // ɾ��һ���ӵ�����
export const URL_SALESCHECK = 'sales/check' // ������ ID �Ƿ���ȷ
export const URL_PREIBCON = 'pre/ibcon' // ������д���Ӷ�𱨱�

export const URL_PRERELATION = 'pre/relation' // ��ù�ϵͼ����

export const URL_DEFAULT = 'tool/default/' // ����Ӷ���趨Ĭ������

export const URL_ACTIVEREPORT = 'pre/status' //�Ѽ����������
export const URL_AUDITREPORT = 'pre/audits' //��˸��ٱ���
export const URL_AUDITREPORTDETAIL = 'pre/audit'

export const URL_REALTIME = "report/realtime" // ʵʱӶ����
export const URL_REALTIMEDETAIL = "report/ibres" // ʵʱӶ����ϸ

export const URL_IBMONTHLYINDEX = "report/monres" // �����½YӶ��
export const URL_IBMONTHLYSECOND = 'report/monibres' // �����½�Ӷ����
export const URL_IBMONTHLYUPDATE = 'report/status' // �����½����״̬
export const URL_IBMONTHLYDETAIL = 'report/monibdet' // �����½���ϸ

export const URL_CPA = 'report/cpa'
export const URL_CPADETAIL = 'report/cpacli'


export const URL_SALEMONTHLYCOMM = 'report/salesres'
export const URL_SALEMONTHLYCOMMDET = 'report/salesdet'

export const URL_TOOLCHECKCPA = 'tool/checkCpa' // ����Ƿ���CPA
export const URL_TOOLCHECKID = 'tool/checkId' // ���id�Ƿ��ڹ�ϵͼ
export const URL_TOOL_ALERT_IGNORE = 'tool/alert_ignore';// Ӷ��������֪ͨ����
export const URL_TOOL_ALERT_IGNORE2 = 'tool/alert_ignore2';

export const URL_MTCLIENTS = 'report/getMTClients'
export const URL_MTDBS = 'report/getMTDbs'

export const URL_TEMPLATE_GET = 'tool/template'
export const URL_TEMPLATE_HISTORY = 'tool/templateHistroy'
export const URL_TEMPLATE_SAVE = 'tool/templateSave'

// profit share setting api
export const URL_ACCOUNT_SETTING = api.profitURL + '/account-setting';
export const URL_UPDATE_SETTING = api.profitURL + '/update-setting';
export const URL_SHARE_REPORT = api.profitURL + '/share-report';
export const URL_SHARE_VERSION = api.profitURL + '/share-version';
export const URL_BEGIN_CALCULATE = api.profitURL + '/begin-calculate';
export const URL_VERSION_BACK = api.profitURL + '/version-back';
export const URL_ADD_ACCOUNT = api.profitURL + '/add-account';



// WEBPACK FOOTER //
// ./src/api/commissionApi.js